/**
 * Created by olga on 27.01.2025
 */

const PhotosTutorial = function () {
    return new TutorialScenario(TutorialScenario.BASIC_TUTORIAL_NAME, {
        listSteps: function () {
            return [PhotosTutorial.createStep()];
        },
        isAvailable: function () {
            return Game.currentGame && !cleverapps.forces.isShown(Forces.KEYPAD);
        }
    });
};

PhotosTutorial.createStep = function () {
    const options = {
        onStart: function () {
            const force = Forces.KEYPAD;
            const photos = cleverapps.Scenes.GetSceneComponent(DifferencesSceneComponent).photos;
            photos.toggleBlur(false);
 
            const area = Game.currentGame.getUndiscoveredAreas().sort((a, b) => b.y - a.y)[0];

            force.finger = function () {
                return {
                    path: [area]
                };
            };

            this.force = cleverapps.forces.create(photos, force);
            cleverapps.tutorial.on("discover_difference", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
        }
    };

    return new TutorialStep(options);
};
